import * as React from "react";
import { forwardRef } from "react";
const SvgHomeOutlined = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.39388 14.3824H18.9358V22.5H23.8298V13.0491L14.1648 5.21769L4.49985 13.0491V22.5H9.39388V14.3824ZM11.8939 25H1.99985V11.8571L14.1648 2L26.3298 11.8571V25H16.4358V16.8824H11.8939V25Z" }));
const ForwardRef = forwardRef(SvgHomeOutlined);
export { ForwardRef as ReactComponent };
